// extracted by css-extract-rspack-plugin
export default {"AdHocLeftSideRoot":"ymK_u"};